export default "__VITE_ASSET__DRZD4Pw1__"